import React, { useState } from 'react'
import BackImg from '../images/background.9d63cb4a.svg'
import nav from '../images/GDSC logo.png'
import closebtn from "../images/closebutton.e5c00b54.svg"
import question from '../images/helpIcon.8216b310.svg'
import "../Componenets/index.css";
import GoogleButton from "react-google-button";
import { useUserAuth } from "../context/UserAuthContext";
import { useNavigate } from "react-router-dom";

const Index = () => {
    const { googleSignIn } = useUserAuth();
    const navigate = useNavigate();

    // const clint_id = "1040307284330-ffo4jjsgmp3ea8lkveishan1aiq60ngs.apps.googleusercontent.com";

    // const onSignIn = (googleUser) => {
    //     const profile = googleUser.getBasicProfile();
    //     console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
    //     console.log('Name: ' + profile.getName());
    //     console.log('Image URL: ' + profile.getImageUrl());
    //     console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    // }

    const handleGoogleSignIn = async (e) => {
        e.preventDefault();
        try {
            await googleSignIn();
            navigate("/auth");
        } catch (error) {
            console.log(error);
        }
    };
    const [sidebar, setSidebar] = useState(true);

    const showSidebar = () => setSidebar(!sidebar);
    return (
        <>
            <div className={sidebar ? "drawer-container" : "drawer-container active"} onClick={showSidebar}>
                <div id="drawer" className='drawer-main shadow-blue' >
                    <div className="w-auto p-4">
                        <div className="w-10 mt-0 ml-auto mr-0 cursor-pointer">
                            <img src={closebtn} alt="close" className="w-10 h-10" onClick={showSidebar} />
                        </div>
                        <div className="pt-4">
                            <span className="text-4xl font-extralight font-workSans">Guidelines</span>
                            <br />
                            <br />
                            <span className="text-xl font-gelionLight">
                                <p>- Register on the portal and finish <strong>Round 1 </strong> before 11:59 PM, 21st August 2022</p>
                                <br />
                                <p>- Before applying please read the Recruitments Guidelines <a href="https://docs.google.com/document/d/1prtNLTob-vfUDGRpzDnqa9VSNxsWsEIcTiJziUOgfi4/edit?usp=sharing" target="_blank" rel="noreferrer"> <span class="font-normal underline font-gelion text-plasticblue"> here </span> </a></p>
                                <br />
                                <p>- Shortlisted candidates will be notified via email.</p>
                            </span>
                        </div>
                        <div className="pt-10 pb-24">
                            <span className="text-4xl font-extralight font-workSans">Selection Process</span>
                            <br />
                            <br />
                            <span className="text-xl font-gelionLight">
                                <p><strong>Round 1: </strong>Round 1 is profile shortlisting. Our team will review the application and selected candidates would be contacted.</p>
                                <br />
                                <p><strong>Round 2: </strong>Round 2 is Online Technical Interview. Round 1 selected candidates would go through interviews based on their selected domain.</p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-full home-container">
                <img src={BackImg} alt="background" className='background-image' />
                <div className="h-full">
                    <div className="absolute object-left-top">
                        <div className="Header_nav-logo">
                            <img src={nav} className="navbar-image" alt="home img" />
                            <p className="text">
                                Google Developer Student Clubs
                                <br />
                                GLA University
                            </p>
                        </div>
                    </div>
                    <div className='question-image' onClick={showSidebar}>
                        <img src={question} alt="question" className='font-gelionMedium' />
                    </div>
                    <div className="helper">
                        <p className="helper-text">
                            Recruitments
                        </p>
                        <p className='header-year'>2022</p>
                        <div style={{marginTop:'20px'}}>
                            {/* <div class="g-signin2" data-onsuccess="onSignIn"></div> */}
                            <GoogleButton
                                className="g-btn"
                                type="dark"
                                // onClick={onSignIn}
                                onClick={handleGoogleSignIn}
                            />
                                {/* <p style={{color: 'red', fontWeight:'600', textAlign:'center', fontSize:'25px'}}>Registration Closed</p> */}
                                {/* <p style={{color: 'green', fontWeight:'600', textAlign:'center', fontSize:'25px'}}>Registration Start in August</p> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Index;